import { Control } from 'react-hook-form';

import { BindingCreator } from '@dreryk/react-common';
import { DateRangePickerLegacy } from '@dreryk/react-components';

import { DateFilter } from '../../../AppointmentsFilterChips/DateChipFilter.types';
import { FilterFormBean } from '../../AppointmentsFilterPanel';

import { useRangeValue, useUpdateUrlFromDateRange } from './DateRangeField.hooks';

type DatePickerFieldType = {
   readonly register: BindingCreator<FilterFormBean>;
   readonly control: Control<FilterFormBean>;
   readonly dateFilterValue: DateFilter['range'] | undefined;
   readonly previousFilterType: DateFilter['type'] | null | undefined;
};

const DateRangeField = (props: DatePickerFieldType): JSX.Element => {
   const rangeValue = useRangeValue(props.previousFilterType, props.dateFilterValue);
   useUpdateUrlFromDateRange(props.control, rangeValue);
   const controller = props.register(DateRangeField.fieldName);

   return <DateRangePickerLegacy controller={controller} horizontal defaultValue={rangeValue} testId={'dateRange'} />;
};
DateRangeField.fieldName = 'date.range' as const;
DateRangeField.displayName = 'AppointmentFilterDateRangeField';

export { DateRangeField };
